var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React from 'react';
export var ContextBridge = (function (_a) {
    var barrierRender = _a.barrierRender, contexts = _a.contexts, children = _a.children;
    var providers = function (values) {
        var getValue = function (i) { return values[values.length - 1 - i]; };
        return React.createElement(React.Fragment, null, contexts.reduce(function (children, Context, i) { return (React.createElement(Context.Provider, { value: getValue(i) }, children)); }, children));
    };
    var consumers = contexts.reduce(function (getChildren, Context) { return (function (values) { return React.createElement(Context.Consumer, null, function (value) { return getChildren(__spreadArray(__spreadArray([], values), [value])); }); }); }, function (values) { return barrierRender(providers(values)); });
    return consumers([]);
});
